import { render, staticRenderFns } from "./CogneetivAI copy.vue?vue&type=template&id=1e1d2db4&"
import script from "./CogneetivAI copy.vue?vue&type=script&lang=js&"
export * from "./CogneetivAI copy.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivAI copy.vue?vue&type=style&index=0&id=1e1d2db4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports